import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-authorize-denied',
  templateUrl: './authorize-denied.component.html',
  styleUrl: './authorize-denied.component.scss',
  imports: [RouterLink],
})
export class AuthorizeDeniedComponent {

}
